// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"App_bannerContainer__yG4f1","coop":"App_coop__2qmfx"};